
import { useNavigate } from 'react-router';
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import FormTemplateCard from './FormTemplateCard';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import { useSelector } from 'react-redux';
import Loader from '../../../component/Loader.jsx';
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import { Privileges } from '../../../util/PrivilegeConstants.js';


const RegistrationSetup = () => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const userInfo = useSelector((store) => store.user.userInfo);
    const navigate = useNavigate();
    const [openPopup, setOpenPopup] = useState(false);
    const [templateData, setTemplateData] = useState({ name: null, error: false });
    const [isLoading, setIsLoading] = useState(false);
    const [formTemplates, setFormTemplates] = useState([]);
    const [privileges, setPrivileges] = useState({});
    const [isRefresh, setIsRefresh] = useState(false);
  

    const createFormTemplate = async () => {
        try {
            if (!templateData.name || templateData?.name.trim() === '') {
                setTemplateData({ ...templateData, error: true });
                return;
            }
            const response = await FormTemplateAPI.postCreateFormTemplate({
                clubId: selectedClub.clubId,
                name: templateData.name,
                createdBy: userInfo.userId
            })
            navigate("/form-settings", {
                state: {
                    formTemplateId: response.Data
                }
            })
        } catch (error) {
            console.log(error);
        }
    };
    const getFormTemplates = async () => {
        try {
            setIsLoading(true)
            const response = await FormTemplateAPI.getAllFormTemplate(selectedClub.clubId);
            setFormTemplates(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };


    const findAllPrivileges = async () => {
        try {
            setIsLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[11]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId])


    useEffect(() => {
        if (selectedClub.clubId) {
            getFormTemplates();
        }
        isRefresh && setIsRefresh(false);
    }, [selectedClub.clubId, isRefresh]);

    return (
        <div className={styles['registration_setup_container']}>
            {isLoading && <Loader />}
            <div className={styles['registration_setup_header']}>
                <h1>Form Templates</h1>
                {privileges?.MANAGE_FORM_TEMPLATE?.includes(Privileges.CREATE) &&
                    <button type='button' onClick={() => setOpenPopup(true)}>Create Form Template</button>}
            </div>
            {(formTemplates?.length != 0 && !isLoading) ?
                <div className={styles['form_card_list']}>
                    {
                        formTemplates?.map((ft, index) =>
                            <FormTemplateCard
                                formTemplate={ft}
                                clubId={selectedClub?.clubId}
                                key={index}
                                userId={userInfo?.userId}
                                setIsLoading={setIsLoading}
                                setIsRefresh={setIsRefresh}
                                privileges={privileges} />
                        )
                    }
                </div>
                :
                <div className='sm_join_request_not_found' style={{ minHeight: '60dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p>No templates on the board yet. Create your first play and set the game in motion!</p>
                </div>}

            <CustomDialog
                title="Enter Template Name"
                isOpen={openPopup}
                onClose={() => setOpenPopup(false)}
                onCancel={() => {
                    setOpenPopup(false);
                    setTemplateData({ name: null, error: false });
                }}
                onSubmit={createFormTemplate}
            >
                <div className={styles['form_template_create_form']}>
                    <TextField
                        error={templateData?.error}
                        helperText={templateData.error && "Enter valid template name"}
                        className={styles['form_text_field_theme']}
                        value={templateData.name || ''}
                        onChange={(e) => setTemplateData({ name: e.target.value, error: false })}
                        fullWidth
                        label="Template Name"
                    />
                </div>
            </CustomDialog>
            
        </div>
    )
}

export default RegistrationSetup
